export interface ISaveIndicationState {
    active: boolean;
}

export const state: ISaveIndicationState = {
    active: false
};
